$(function () {
  let options = {};
  if ( $(".js-single-slider .swiper-slide").length == 1 ) {
    options = {
      loop: false
    }
  } else {
    options = {
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				waitForTransition: false,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: '.swiper-pagination',
			},
    }
  }

	const articleSlider = document.querySelectorAll('.js-single-slider');
	for (let i = 0; i < articleSlider.length; i++) {
		new Swiper(articleSlider[i], options);
	}
});
